import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { lexikonPath, type LexikonTerm } from "@/lib/lexikon";

/**
 * Karte eines Lexikon-Begriffs in der Übersicht. Entrance per CSS (.enter in
 * globals.css) statt framer-motion: Die Übersicht rendert alle ~50 Karten auf
 * einmal, und 50 JS-Animationen beim Laden kosteten auf dem Handy spürbar
 * Main-Thread-Zeit; außerdem sind die Karten so schon vor der Hydration sichtbar.
 */
export default function LexikonCard({
  term,
  index,
}: {
  term: LexikonTerm;
  /** Position in the entrance stagger; omit to render without animation. */
  index?: number;
}) {
  return (
    <div
      className={index === undefined ? undefined : "enter"}
      style={index === undefined ? undefined : { animationDelay: `${index * 0.05}s` }}
    >
      <Link
        href={lexikonPath(term.slug)}
        className="card-flat group flex h-full flex-col gap-2 bg-white p-6 transition-all duration-200 hover:-translate-y-0.5"
      >
        <div className="flex items-start justify-between gap-3">
          <h3 className="min-w-0 break-words hyphens-auto font-display font-bold text-lg text-ink leading-snug group-hover:text-accent transition-colors">
            {term.term}
          </h3>
          <ArrowUpRight
            size={18}
            className="mt-1 shrink-0 text-ink-faint group-hover:text-accent group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200"
            aria-hidden="true"
          />
        </div>
        <p className="text-sm text-ink-soft leading-relaxed">{term.short}</p>
        <span className="mt-auto pt-2 text-xs font-bold uppercase tracking-widest text-ink-faint">
          {term.category}
        </span>
      </Link>
    </div>
  );
}
